import React, { useEffect } from "react";
import {
  Route,
  Switch,
  Redirect,
  useParams,
  useRouteMatch,
} from "react-router";
import List from "./List";
import FormCreate from "./create"
import { FormCreatev2 } from "../../forms/formBuilder"
import { useDispatch } from "react-redux";
import { selectedForm } from "../../../../stateManager/store/formCreation/action";

const Forms = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const match: any = useRouteMatch();
  const redirectUrl = match.path.replace(":appId", params.appId) + "/list"

  useEffect(() => {
    if (match) {
      dispatch(selectedForm(""));
    }
  }, [match, dispatch])

  return (
    <Switch>
      <Route exact path={`${match.path}/list/:formId/create`} component={FormCreate} />
      <Route exact path={`${match.path}/list/:formId/createv2`} component={FormCreatev2} />
      <Route exact path={`${match.path}/list`} component={List} />
      <Route component={() => <Redirect to={redirectUrl} />} />
    </Switch>
  );
};

export default Forms;
